
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M18.462 7.813v14.062c0 1.726-1.378 3.125-3.078 3.125H4.615c-1.7 0-3.077-1.4-3.077-3.125V7.812C.688 7.813 0 7.112 0 6.25V4.687a1.55 1.55 0 011.538-1.562h4.615V1.562C6.153.7 6.843 0 7.692 0h4.616c.849 0 1.537.7 1.537 1.563v1.562h4.617c.849 0 1.538.7 1.538 1.563V6.25c0 .862-.69 1.563-1.538 1.563zm-15.385 0v14.062a1.55 1.55 0 001.538 1.563h10.769c.85 0 1.54-.7 1.54-1.563V7.812H3.076zm4.615-4.688v-.781c0-.432.344-.781.77-.781h3.077c.424 0 .769.349.769.78v.782H7.692zm10 1.563H2.308c-.426 0-.77.349-.77.78 0 .432.344.782.77.782h15.384c.425 0 .77-.35.77-.781a.775.775 0 00-.77-.782zM6.153 10.936c.425 0 .77.35.77.782v9.375a.776.776 0 01-.77.781.775.775 0 01-.768-.781v-9.375c0-.432.343-.782.768-.782zm3.847 0c.425 0 .768.35.768.782v9.375a.775.775 0 01-.768.781.776.776 0 01-.77-.781v-9.375c0-.432.345-.782.77-.782zm3.845 0c.426 0 .77.35.77.782v9.375a.776.776 0 01-.77.781.775.775 0 01-.768-.781v-9.375c0-.432.344-.782.768-.782z","fill":"#DE3831"}})])
          )
        }
      }
    